import { SETTINGS } from "./data";

// Pengaturan kontak kini statis — berasal dari src/lib/data.js
export function useSettings() {
  return SETTINGS;
}
